import {Modificator, ModificatorOption} from "@/gql/gen";
import {ProductModel} from "@/modules/shop/composable/useProduct";


export type ProductModificatorVal = Record<string, number>
export type ProductModificatorValues = Record<string, ProductModificatorVal>

export function isChildModificator(mod: Modificator) {
    return mod.TYPE === 'constructor' || mod.TYPE === 'additive' || mod.TYPE === 'gift' || mod.TYPE === 'special'
}


// Расширенный тип для объединения доступных и потенциальных товаров
export interface SuggestedModificatorProduct {
    option: ModificatorOption;
    product: ProductModel;
    modificator: Modificator;
    isAvailable: boolean; // true - доступен для добавления, false - потенциальный (нужно выполнить условия)
    priceRemaining?: number; // Сколько не хватает до активации (для глобальных модификаторов)
    progressPercent?: number; // Процент прогресса (0-100)
}
